<template>

    <div class="header-wrapper">
      <img lass="logo" alt="LIFT EXPERTS" src="../assets/images/top-header-01.png"/>
      <div class="pageTitle-wrap poppins-semi fontColor2">{{ titleMsg }}</div>
    </div>

    <div class="montserrat-600 sub-text-one sub-text-title-wrap">
        {{ msg }}
    </div>
</template>

<script>
export default {
  name: 'ThePageSubTitle',
  props: {
    titleMsg: String,
    msg: String,
  },
}

</script>

<style scoped>
.sub-text-title-wrap{
    text-align: center;
    color: #666666;
}

.header-wrapper{
  position: relative;
  margin: 0 auto;
  text-align: center;
  width: 251px;
}
.pageTitle-wrap{
  position: absolute;
  bottom: 10px;
  left: 94px;
  font-size: 18px;
}

.header-wrapper img{
  width: 100%;
}

@media screen and (min-width: 570px) {
  .pageTitle-wrap{
    font-size: 22px;
    letter-spacing: 4px;
  }
}

@media screen and (min-width: 760px) {
  .header-wrapper{
    width: 461px;
  }
  .pageTitle-wrap{
    left: 164px;
    font-size: 26px;
  }
}


</style>